import { IRpcService } from '../RpcService';
import { IDonateItemService } from './donateItemServiceTypes';

export class DonateItemService implements IDonateItemService {
	constructor(private readonly rpc: IRpcService) {}

	public async exitMenu(): Promise<void> {
		await this.rpc.invokeClient('donateItem:exitMenu');
	}
}
